export enum AlertPosition {
  TOP_LEFT = 'top-left',
  TOP_CENTER = 'top-center',
  TOP_RIGHT = 'top-right',
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM_CENTER = 'bottom-center',
  BOTTOM_RIGHT = 'bottom-right',
}

export interface AlertConfig {
  position: AlertPosition;
  maxAlerts: number;
  defaultDuration: number;
  enableAnimations: boolean;
  enableSound: boolean;
  stackAlerts: boolean;
  newestOnTop: boolean;
}
